import httpService from './httpService';
import qs from 'querystring';

class api {
  onUnauthorized(action) {
    httpService.onUnauthorized(action);
  }
  login(credentials, env = process.env.REACT_APP_DB, headers = {}, signal) {
    return httpService.post(
      'usuario/login',
      qs.stringify({ ...credentials, env, grant_type: 'password' }), //data
      { 'Content-Type': 'application/x-www-form-urlencoded', ...headers }, //headers
      signal
    );
  }
  getClaims = signal => httpService.get('usuario/claims', signal);

  //caixa de aprovação
  buscarChavesAprovacao = () => httpService.get('chaves');
  aprovarChaves = data => httpService.post('chaves/aprovar', data);
  reprovarChaves = data => httpService.post('chaves/reprovar', data);
  verificarTemChaveNaCaixa = signal =>
    httpService.get('chaves/verificar', signal);

  //usuários
  buscarUsuariosPorTermo = termo =>
    httpService.get('usuario/list?termo=' + termo);

  //atendimento
  criarOuEditarConfigAtendente = config =>
    httpService.post('agendamento/atendente/atualizar', config);
  buscarLocaisAtendimento = codigoUsuario => {
    let url = 'agendamento/locais';
    if (codigoUsuario) url += '?codigoUsuario=' + codigoUsuario;
    return httpService.get(url);
  };
  buscarServicos = agendavel =>
    httpService.get(
      'agendamento/servicos' + (agendavel ? '?agendavel=true' : '')
    );
  atualizarServico = model =>
    httpService.post('agendamento/servico/atualizar', model);
  atualizarEscalasServico = model =>
    httpService.post('agendamento/servico/escalas/atualizar', model);
  buscarParametrosAgendamento = () =>
    httpService.get('agendamento/servicos/config');
  atualizarParametroMaximoAtendimentosPorDia = config =>
    httpService.post('agendamento/servicos/config', config);
  buscarUsuariosAtendentes = () => httpService.get('agendamento/atendentes');
  excluirConfiguracoesAtendimentoUsuario = codigoUsuario =>
    httpService.get(`agendamento/atendente/${codigoUsuario}/excluir`);
  buscarAgendamentos = filtros =>
    httpService.post('agendamento/lista', filtros);
  buscarDisponibilidadeServico = filtros =>
    httpService.post('agendamento/disponibilidade', filtros);
  buscarCalendarios = () => httpService.get(`agendamento/calendarios`);
  criarAgendamento = model => httpService.post('agendamento/criar', model);
  buscarAtendentesComHorarios = (termo, diaDaSemana) =>
    httpService.get(
      `agendamento/atendentes/buscar?termo=${termo}&diaDaSemana=${diaDaSemana}`
    );
  buscarRelatorioAgendamento = filtros =>
    httpService.post('agendamento/relatorio', filtros);

  buscarGesValidos = codigo_usuario =>
    httpService.get(
      `solicitacao/obter-ges${
        codigo_usuario ? '?codigoUsuario=' + codigo_usuario : ''
      }`
    );

  obterFiltrosFornecedores = ge =>
    httpService.get(`solicitacao/obter-fornecedores/${ge}`);

  buscarFiltrosRestantes = request =>
    httpService.post('solicitacao/obter-filtros', request);
  salvarDados = dados => httpService.post('solicitacao/salvar', dados);
  AtualizarSolicitacaoDespesaProjeto = dados =>
    httpService.post('solicitacao/atualizar', dados);

  buscarFiltroCentroDeCusto = (ge, codigo_conta) =>
    httpService.get(
      `solicitacao/obter-filtro/centrodecusto/${ge}/${codigo_conta}`
    );

  buscarSolicitacoes = request =>
    httpService.post('solicitacao/obter-solicitacoes', request);
  excluirArquivo = request =>
    httpService.post('solicitacao/excluir-digitalizacao', request);
  aprovarSolicitacao = (request, justificativa) =>
    httpService.post('solicitacao/aprovar', request, justificativa);
  recusarSolicitacao = request =>
    httpService.post('solicitacao/recusar', request);
  changeStatusSolicitacao = request =>
    httpService.post('solicitacao/change-status/despesa-projeto', request);
  verificarStatusEResponsavelAnalise = codigoSolicitado =>
    httpService.get(
      `solicitacao/validar-responsavel-analise/${codigoSolicitado}`
    );
  buscarRelatorioComissoes = request =>
    httpService.post('comissao/relatorio/buscar', request);

  buscarEmpreendimentos = () => httpService.get('opcao/empreendimento');

  buscarRelatorioChaves = filtro =>
    httpService.post('chaves/buscar/relatorio', filtro);

  buscarDepartamentos = () =>
    httpService.get('solicitacao/obter-departamentos');

  buscarUsuarios = () => httpService.get('usuario');

  buscarLogStatusDespesaProjeto = codigoDespesaProjeto =>
    httpService.get(`solicitacao/${codigoDespesaProjeto}/historico`);

  buscarRelatorioSolicitacoes = filtro =>
    httpService.post('solicitacao/buscar/relatorio', filtro);

  buscarStatusSolicitacao = () =>
    httpService.get('solicitacao/obter-status');
}

export default new api();
